import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import { Button as BootstrapButton } from 'reactstrap';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles({
    root: {
        //maxWidth: 345,
        width: '100%',
    },
    media: {
        height: 140,
    },

    main: {
      display: 'flex'
    },
    col1: {
        border: '1px solid black',
        width: '100px'
    },
    col2: {
        border: '1px solid red',
        flexGrow: 1
    },
    break: {
        flexBasis: '100%',
        height: 0
    },
    prdcard: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
    }
});

function MediaCard(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    var _props = { ...props };
    if (!_props.style) _props.style = {};
    //if (!_props.style.backgroundColor) _props.style.backgroundColor = '';
    //if (_props.style.backgroundColor == '') _props.style.backgroundColor = '#F8F8F8';
    if (!_props.cleartext) _props.cleartext = 'X';

    if (!_props.cardcolor) _props.cardcolor = '#d6d6d6';

    //_props.style.height = '100%';

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Card className={classes.root} style={_props.style} className={_props.className}>
                <CardContent style={{ padding: '5px', backgroundColor: _props.cardcolor}}>
                <div className="clearfix" style={{ fontSize: 'large', marginBottom: '0px' }}>
                        <div style={{ position: 'relative' }}>
                            {props.clear ?
                                <div style={{ position: 'absolute', right: '-21px', top: '-4px' }}>
                                    <Button size="small" color="primary" onClick={() => props.clear()}>
                                        <CloseIcon style={{
                                            background: 'rgb(214, 214, 214, 1)',
                                            borderColor: 'rgb(214, 214, 214)',
                                            boxShadow: '-4px 0 7px rgb(214 214 214)'
                                        }} /></Button>
                                </div>
                                :
                                <div style={{ position: 'absolute', right: '0px', top: '-4px' }}>
                                    <div style={{ fontSize: 'smaller' }}>{props.sch ? props.sch : null}</div>
                                </div>
                            }

                            <div style={{ position: 'absolute', right: '-21px', top: '-4px' }}>
                                {props.refresh ?
                                    <Button size="small" color="primary" onClick={() => props.refresh()}><RefreshIcon /></Button> : null
                                }
                            </div>
                            </div>
                        <div style={{ float: 'left', padding: '0px 0px' }}>{props.title}</div>
                    <div style={{ float: 'left', padding: '4px 5px' }}>
                        {props.moreInfo ? <Button size="small" color="primary" onClick={handleClickOpen}>More Info</Button> : ''}
                        {props.helpInfo && (!props.clear || props.type == '3') ? <Button size="small" color="primary" onClick={handleClickOpen}>Help Me Choose</Button> : ''}
                    </div>

                </div>
                    {props.infobox ? <div style={{ padding: '0 5px 15px 5px', fontSize: 'smaller' }}>{props.infobox}</div> : null}
                    {props.infobox2 ? <div style={{ padding: '0 5px 15px 5px', fontSize: 'smaller' }}>{props.infobox2}</div> : null}
                <div>{props.children}</div>
                </CardContent>
        </Card>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">{"Help Me Choose the " + props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.helpInfo}
                    </DialogContentText>
                    {!props.helpLink ? null :
                        <div style={{ textAlign: "center" }}>
                            <Button color="primary" href={props.helpLink} target="_blank">
                                {props.helpLinkText}
                            </Button>
                        </div>
                    }
                </DialogContent>

                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        Ok
                    </Button>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

function ActionCard(props) {
    const classes = useStyles();
    
    let _s =
        props.disabled ?
            { border: '2px solid #e0e0e0', backgroundColor: '#e0e0e0' } :
            props.selected ?
                { border: '2px solid #007db8', backgroundColor: '#f0f8ff' } :
                { border: '2px solid silver', backgroundColor: 'white' };
    //_s.height = '100%';
    
    //if role is lead-in, style with centered text themed button
    let btnTextAlign = props.role === "lead-in" ? "center" : "left";
    let themeButton = props.theme + '-btn';
    let themeText = props.theme + '-text';

    let links = props.link01 || props.link02 || props.link03;
    let css = null;//{ height: '100%' };//!links ? { height: '100%' } : null;
    
    let props_src = props.src;
    props_src = "https://www.ctconline.com" + props_src;

    return (
        <Card 
            className={'stretch-and-vcenter ' + classes.root +
                (props.disabled ? " disabled" : (props.selected ? " selected" : " notselected"))}
            variant="outlined" style={{
                width: '100%',
                minHeight: '60px',

            }}>

            


            <div className={'prd-flex-container '+props.class2} onClick={props.onClick} disabled={props.disabled ? true : false} style={{ width: '100%' }}>
                <div className="prd-flex-item prd-img stretch-and-vcenter">
                    {props.src ?
                        <div style={{ width: '100%' }}>
                            <img src={props_src} style={{ padding: '5px' }} onError={i => i.target.style.display = 'none'} />
                        </div>
                        : null}

                </div>
                <div className={'prd-flex-item prd-text stretch-and-vcenter ' + (props.role === "lead-in" ? themeButton : "")}>
                    <div style={{ width: '100%' }}>
                        <div style={{ textAlign: btnTextAlign, padding: '15px' }}>{props.title}
                            {props.moreInfo ? <Button size="small" color="primary">More Info</Button> : ''}
                            {props.helpInfo ? <Button size="small" color="primary">Help Me Choose</Button> : ''}
                            {props.clear ? <Button size="small" color="primary" onClick={() => props.clear()}>Clear</Button> : ''}
                        </div>
                        {props.children ?
                        <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '-10px', padding: '10px' }}>{props.children}</div>
                        : null}
                    </div>
                </div>
                {!links ? null :
                    <React.Fragment>
                    <div className="prd-flex-item"></div>
                        <div className="prd-flex-item"><div style={{ width: props.src ? '112px' : '1px' }}></div></div>
                    <div className="prd-flex-item prd-links">
                            <CardActions style={{ display: 'block', textAlign: 'left', padding: '15px' }}>
                                {!props.link02 ? null : <span><strong>View Datasheets: </strong></span>}
                                {!props.link01 ? null : <BootstrapButton onClick={(e) => { e.stopPropagation(); }} size="sm" color="secondary" href={props.link01} target="_blank">{props.linktext01}</BootstrapButton>}
                                {!props.link02 ? null : <BootstrapButton onClick={(e) => { e.stopPropagation(); }} size="sm" color="secondary" href={props.link02} target="_blank">{props.linktext02}</BootstrapButton>}
                                {!props.link03 ? null : <BootstrapButton onClick={(e) => { e.stopPropagation(); }} size="sm" color="secondary" href={props.link03} target="_blank">{props.linktext03}</BootstrapButton>}
                        </CardActions>
                    </div>
                    </React.Fragment>
                }
            </div>



            
        </Card>
    );
}

export {
    MediaCard,
    ActionCard,
}